import { FC } from 'react'
import type { IconProps, IconWithSubcomponents, SVGComponent } from './Icon.types'
import * as Icons from './svg_components'

/**
 * Base component for all icons. Should not be used directly, it's only exported for Storybook.
 * @param name - The name of the icon to display.
 * @param size - The size of the icon.
 * @param color - The color of the icon.
 * @param props - Additional props to pass to the icon (className, onClick, etc.)
 * @returns The icon component.
 */
export const IconBase: FC<IconProps> = ({ name, size = 24, color, ...props }) => {
	const IconSvg = (Icons as Record<string, SVGComponent>)[name]

	return (
		<IconSvg
			width={size}
			height={size}
			style={{ color }}
			{...props}
		/>
	)
}

export const Icon = Object.keys(Icons).reduce((acc, name) => {
	const SubComponent: FC<Omit<IconProps, 'name'>> = (props) => (
		<IconBase
			name={name as keyof typeof Icons}
			{...props}
		/>
	)

	acc[name as keyof typeof Icons] = SubComponent
	return acc
}, IconBase as IconWithSubcomponents)
